module.exports = __webpack_public_path__ + "static/media/1.13_preview.4df1f0b6.png";